// extracted by mini-css-extract-plugin
module.exports = {"inner":"ConfirmDeleteAvatarModal_inner__1VGzi","modalWrapper":"ConfirmDeleteAvatarModal_modalWrapper__1Nr-f"};